export default __webpack_public_path__ + "00dd8a5de09c5531960f4c20c11f3206.png";